export default __webpack_public_path__ + "static/media/oxygen7-logo.f29ad090.png";